import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerListDataService } from 'src/app/services/customer-list-data.service';
import { ToastrService } from 'ngx-toastr';
import { countries } from '../../Utils/countries';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-missing-user-data',
  templateUrl: './missing-user-data.component.html',
  styleUrls: ['./missing-user-data.component.css'],
})
export class MissingUserDataComponent implements OnInit {
  userList: any[] = [];
  p: number = 1;
  total: number = 0;
  count: number = 0;
  itemsPerPage: number = 10;
  countries = countries;

  maritalStatusOptions = [
    'Divorced',
    'Married',
    'Never married',
    'Separated',
    'Widowed',
  ];
  childStatusOptions = ['Has children', 'No children'];
  religionOptions = [
    'Agnostic',
    'Atheist',
    'Buddhist',
    'Catholic',
    'Christian',
    'Hindu',
    'Jewish',
    'Muslim',
    'Other',
    'Prefer not to say',
    'Sikh',
    'Spiritual',
  ];

  baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router
  ) {}
  goToCustomerDetail(userId: string | number) {
    this.router.navigate([`/customer-detail/${userId}/approved`]);
  }

  ngOnInit(): void {
    this.getUsers(this.p);
  }

  getUsers(page: number) {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    // Using direct HTTP call as the service method might not exist yet or I want to be specific
    // Assuming base URL is in environment
    const url = `${this.baseUrl}/getUsersWithMissingData?page=${page}`;

    this.http.get(url, { headers }).subscribe(
      (res: any) => {
        if (res && res.status === 200) {
          this.userList = res.data;
          // Assuming metadata format from similar APIs, adjust if needed
          // The user prompt said "it will have data and mata" (meta)
          // Adjusting based on typical response structure or user prompt
          this.userList = res.data.data || res.data;
          // If there is meta for pagination
          if (res.data.meta) {
            this.total = res.data.meta.totalItems || res.data.meta.total || 0;
            this.count = res.data.meta.totalItems || res.data.meta.total || 0;
            this.itemsPerPage = res.data.meta.itemsPerPage || 10;
          }
        } else {
          this.toastr.error(res.message || 'Failed to fetch users');
        }
      },
      (err) => {
        this.toastr.error('Error fetching data');
        console.error(err);
      }
    );
  }

  onPageChange(page: number) {
    this.p = page;
    this.getUsers(page);
  }

  saveUser(user: any) {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    // Prepare body
    // "expect body with user_id and atleast one of this field"
    const body = {
      user_id: user.id,
      dateOfBirth: user.dateOfBirth,
      gender: user.gender,
      nationality: user.nationality,
      marital_status: user.marital_status,
      child_status: user.child_status,
      religion: user.religion,
    };

    const url = `${this.baseUrl}/adminUpdateUser`;

    this.http.post(url, body, { headers }).subscribe(
      (res: any) => {
        if (res && res.status === 200) {
          this.toastr.success('User updated successfully');
        } else {
          this.toastr.error(res.message || 'Failed to update user');
        }
      },
      (err) => {
        this.toastr.error('Error updating user');
        console.error(err);
      }
    );
  }
}
